import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import select2 from 'select2';

((drupalSettings) => {
  Drupal.behaviors.troax_navigation = {
    attach() {
      $('#market-selector-form select')
        .once('troax_navigation')
        .each((i, element) => this.init(element));
    },
    init() {
      // Location select list.
      $('#market_selector_location').select2({
        templateResult: this.formatState,
        templateSelection: this.formatState,
        minimumResultsForSearch: -1,
        theme: 'troax',
        width: '100%',
      });

      // Language select list.
      $('#market_selector_language').select2({
        minimumResultsForSearch: -1,
        theme: 'troax',
        width: '100%',
      });
    },
    formatState(state) {
      if (!state.id) {
        return state.text;
      }

      const src = `${drupalSettings.troax_navigation.flags_dir}/flags/${state.element.value.toLowerCase()}.svg`;
      const $state = $(`<span>
          <img class="img-flag troax_navigation__market_switcher" />
          <span></span></span>`);

      $state.find('span').text(state.text);
      $state.find('img').attr('src', src);

      return $state;
    },
  };
})(drupalSettings);
